import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "envelope-details-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("section", { class: "envelope-details-header-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Detalhes do Documento")
], -1)
const _hoisted_3 = { class: "envelope-details-content" }
const _hoisted_4 = { class: "details-header" }
const _hoisted_5 = { class: "header-filter" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "header-info" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Nome"),
  /*#__PURE__*/_createElementVNode("div", null, "Canal de coleta"),
  /*#__PURE__*/_createElementVNode("div", null, "Autenticar por")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "header-actions" }, null, -1)
const _hoisted_8 = { class: "details-content" }
const _hoisted_9 = {
  key: 0,
  class: "ic-data"
}
const _hoisted_10 = {
  key: 0,
  class: "ic-order"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = {
  key: 0,
  class: "ic-status"
}
const _hoisted_16 = {
  key: 1,
  class: "ic-status"
}
const _hoisted_17 = {
  key: 2,
  class: "ic-status"
}
const _hoisted_18 = {
  key: 3,
  class: "ic-status"
}
const _hoisted_19 = { class: "info-data" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { key: 3 }
const _hoisted_27 = {
  key: 3,
  class: "data-mode-edit"
}
const _hoisted_28 = { class: "action-name" }
const _hoisted_29 = { class: "action-channels" }
const _hoisted_30 = {
  key: 0,
  class: "channel-email"
}
const _hoisted_31 = /*#__PURE__*/_createTextVNode("E-mail")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Whatsapp")
const _hoisted_33 = {
  key: 1,
  class: "channel-phone"
}
const _hoisted_34 = ["value", "selected"]
const _hoisted_35 = { key: 0 }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("E-mail")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Whatsapp")
const _hoisted_38 = {
  key: 0,
  class: "action-docs"
}
const _hoisted_39 = /*#__PURE__*/_createTextVNode("CPF")
const _hoisted_40 = /*#__PURE__*/_createTextVNode("RG")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("OUTRO")
const _hoisted_42 = /*#__PURE__*/_createTextVNode("CPF")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("RG")
const _hoisted_44 = /*#__PURE__*/_createTextVNode("OUTRO")
const _hoisted_45 = { class: "action-btn" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode("Cancelar")
const _hoisted_47 = /*#__PURE__*/_createTextVNode("Salvar")
const _hoisted_48 = {
  key: 1,
  class: "actions-data"
}
const _hoisted_49 = ["onClick"]
const _hoisted_50 = /*#__PURE__*/_createTextVNode("  Editar destinatário")
const _hoisted_51 = ["onClick"]
const _hoisted_52 = /*#__PURE__*/_createTextVNode("  Link de assinatura")
const _hoisted_53 = ["onClick"]
const _hoisted_54 = /*#__PURE__*/_createTextVNode("  Reenviar notificação")
const _hoisted_55 = { class: "show-link-sign-recipient" }
const _hoisted_56 = { class: "show-link-header" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("h2", null, "Link individual de assinatura", -1)
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" O link individual de assinatura pode ser usado apenas para acessar e assinar o documento em nome de ")
const _hoisted_59 = { class: "copy-link" }
const _hoisted_60 = { class: "copy-link-obs" }
const _hoisted_61 = /*#__PURE__*/_createTextVNode("   Não compartilhe este link com outros destinatários! ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseOutlined = _resolveComponent("CloseOutlined")!
  const _component_FilterFilled = _resolveComponent("FilterFilled")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_InfoCircleOutlined = _resolveComponent("InfoCircleOutlined")!
  const _component_CheckCircleOutlined = _resolveComponent("CheckCircleOutlined")!
  const _component_CloseCircleOutlined = _resolveComponent("CloseCircleOutlined")!
  const _component_SolutionOutlined = _resolveComponent("SolutionOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_EditOutlined = _resolveComponent("EditOutlined")!
  const _component_LinkOutlined = _resolveComponent("LinkOutlined")!
  const _component_RetweetOutlined = _resolveComponent("RetweetOutlined")!
  const _component_MoreOutlined = _resolveComponent("MoreOutlined")!
  const _component_CopyOutlined = _resolveComponent("CopyOutlined")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("span", {
        class: "envelope-details-close",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModalDetails && _ctx.closeModalDetails(...args)))
      }, [
        _createVNode(_component_CloseOutlined)
      ]),
      _hoisted_2
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_a_dropdown, { trigger: ['click'] }, {
            overlay: _withCtx(() => [
              _createVNode(_component_a_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_menu_item, { key: "0" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterRecipientByStatus(1)))
                      }, "Pendente")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_menu_item, { key: "1" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.filterRecipientByStatus(2)))
                      }, "Assinado")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_menu_item, { key: "2" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.filterRecipientByStatus && _ctx.filterRecipientByStatus(...args)))
                      }, "Todos")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("a", {
                class: "ant-dropdown-link",
                onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
              }, [
                _createVNode(_component_FilterFilled)
              ])
            ]),
            _: 1
          })
        ]),
        _hoisted_6,
        _hoisted_7
      ]),
      _createElementVNode("section", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signatureRequests, (item) => {
          return (_openBlock(), _createElementBlock("section", {
            key: item.id,
            style: {"width":"100%"}
          }, [
            _createElementVNode("section", {
              class: _normalizeClass(["box-detail", _ctx.getClassStatus(item)])
            }, [
              (!item.isModeEdit)
                ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
                    (this.isEnvelopeOrder)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(item.order) + "°", 1))
                      : _createCommentVNode("", true),
                    _createVNode(_component_a_tooltip, { placement: "right" }, {
                      title: _withCtx(() => [
                        (item.status == 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Pendente"))
                          : _createCommentVNode("", true),
                        (item.status == 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Assinado"))
                          : _createCommentVNode("", true),
                        (item.status == 3 || item.status == 4)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Cancelado/Rejeitado"))
                          : _createCommentVNode("", true),
                        (item.status == 5)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Observador"))
                          : _createCommentVNode("", true)
                      ]),
                      default: _withCtx(() => [
                        (item.status == 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                              _createVNode(_component_InfoCircleOutlined)
                            ]))
                          : _createCommentVNode("", true),
                        (item.status == 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                              _createVNode(_component_CheckCircleOutlined)
                            ]))
                          : _createCommentVNode("", true),
                        (item.status == 3 || item.status == 4)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                              _createVNode(_component_CloseCircleOutlined)
                            ]))
                          : _createCommentVNode("", true),
                        (item.status == 5)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                              _createVNode(_component_SolutionOutlined)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("section", _hoisted_19, [
                (!item.isModeEdit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(item.partName), 1))
                  : _createCommentVNode("", true),
                (!item.isModeEdit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(item.email) + " " + _toDisplayString(item.phone), 1))
                  : _createCommentVNode("", true),
                (!item.isModeEdit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      (item.documentType !== '' && item.documentType !== 'OTHER' && !item.isUser)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(item.documentType) + " : " + _toDisplayString(item.document), 1))
                        : _createCommentVNode("", true),
                      (item.documentType === 'OTHER' && !item.isUser)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, " Outro documento : " + _toDisplayString(item.document), 1))
                        : _createCommentVNode("", true),
                      (item.isUser)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Autenticação via senha do Certificata"))
                        : _createCommentVNode("", true),
                      (item.documentType === '' && item.status === 5)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Não requer assinatura"))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (item.isModeEdit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_a_input, {
                          value: _ctx.envelopeRecipient.PartName,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.envelopeRecipient.PartName) = $event)),
                          placeholder: "Nome completo conforme o documento"
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        (!_ctx.envelopeRecipient.isWhatsapp)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                              _createVNode(_component_a_input, {
                                value: _ctx.envelopeRecipient.Email,
                                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.envelopeRecipient.Email) = $event)),
                                placeholder: "Digite um e-mail válido",
                                class: "input-email"
                              }, {
                                addonAfter: _withCtx(() => [
                                  _createVNode(_component_a_select, {
                                    value: _ctx.envelopeRecipient.isWhatsapp,
                                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.envelopeRecipient.isWhatsapp) = $event)),
                                    onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeTypeChannelRecipient())),
                                    class: "change-channel"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_select_option, { value: false }, {
                                        default: _withCtx(() => [
                                          _hoisted_31
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_select_option, { value: true }, {
                                        default: _withCtx(() => [
                                          _hoisted_32
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["value"])
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.envelopeRecipient.isWhatsapp)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["flag", _ctx.envelopeRecipient.PhoneFlag])
                              }, null, 2),
                              (_ctx.envelopeRecipient.isWhatsapp)
                                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                    key: 0,
                                    class: "select-countries",
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.envelopeRecipient.PhoneCode) = $event)),
                                    onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changeCountryWhatsRecipient()))
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countriesWhatsapp, (country) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        value: country.ddi,
                                        key: country.sigla,
                                        selected: country.sigla == 'BR'
                                      }, _toDisplayString(country.name), 9, _hoisted_34))
                                    }), 128))
                                  ], 544)), [
                                    [_vModelSelect, _ctx.envelopeRecipient.PhoneCode]
                                  ])
                                : _createCommentVNode("", true),
                              (_ctx.envelopeRecipient.isWhatsapp)
                                ? _withDirectives((_openBlock(), _createBlock(_component_a_input, {
                                    key: 1,
                                    value: _ctx.envelopeRecipient.Phone,
                                    "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.envelopeRecipient.Phone) = $event)),
                                    class: "input-phone"
                                  }, {
                                    addonBefore: _withCtx(() => [
                                      (_ctx.envelopeRecipient.PhoneCode != '')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.envelopeRecipient.PhoneCode), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    addonAfter: _withCtx(() => [
                                      _createVNode(_component_a_select, {
                                        value: _ctx.envelopeRecipient.isWhatsapp,
                                        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.envelopeRecipient.isWhatsapp) = $event)),
                                        onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.changeTypeChannelRecipient())),
                                        class: "change-channel"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_select_option, { value: false }, {
                                            default: _withCtx(() => [
                                              _hoisted_36
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_a_select_option, { value: true }, {
                                            default: _withCtx(() => [
                                              _hoisted_37
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["value"])
                                    ]),
                                    _: 1
                                  }, 8, ["value"])), [
                                    [_directive_maska, _ctx.envelopeRecipient.PhoneMask]
                                  ])
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (item.status !== 5)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            (_ctx.envelopeRecipient.isDocCPF)
                              ? _withDirectives((_openBlock(), _createBlock(_component_a_input, {
                                  key: 0,
                                  value: _ctx.envelopeRecipient.Document,
                                  "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.envelopeRecipient.Document) = $event)),
                                  placeholder: "Preencha o número do documento",
                                  class: "input-doc",
                                  onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.validateCPF(_ctx.envelopeRecipient.Document, _ctx.envelopeRecipient.isDocCPF, true)))
                                }, {
                                  addonAfter: _withCtx(() => [
                                    _createVNode(_component_a_select, {
                                      value: _ctx.envelopeRecipient.DocumentType,
                                      "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.envelopeRecipient.DocumentType) = $event)),
                                      onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.changeTypeDocRecipient())),
                                      class: "change-doc"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_select_option, { value: "CPF" }, {
                                          default: _withCtx(() => [
                                            _hoisted_39
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_select_option, { value: "RG" }, {
                                          default: _withCtx(() => [
                                            _hoisted_40
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_select_option, { value: "OTHER" }, {
                                          default: _withCtx(() => [
                                            _hoisted_41
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["value"])
                                  ]),
                                  _: 1
                                }, 8, ["value"])), [
                                  [_directive_maska, _ctx.envelopeRecipient.docMask]
                                ])
                              : _createCommentVNode("", true),
                            (_ctx.envelopeRecipient.isDocRG || _ctx.envelopeRecipient.isDocOther)
                              ? (_openBlock(), _createBlock(_component_a_input, {
                                  key: 1,
                                  value: _ctx.envelopeRecipient.Document,
                                  "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.envelopeRecipient.Document) = $event)),
                                  placeholder: "Preencha o número do documento",
                                  class: "input-doc"
                                }, {
                                  addonAfter: _withCtx(() => [
                                    _createVNode(_component_a_select, {
                                      value: _ctx.envelopeRecipient.DocumentType,
                                      "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.envelopeRecipient.DocumentType) = $event)),
                                      onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.changeTypeDocRecipient())),
                                      class: "change-doc"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_select_option, { value: "CPF" }, {
                                          default: _withCtx(() => [
                                            _hoisted_42
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_select_option, { value: "RG" }, {
                                          default: _withCtx(() => [
                                            _hoisted_43
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_select_option, { value: "OTHER" }, {
                                          default: _withCtx(() => [
                                            _hoisted_44
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["value"])
                                  ]),
                                  _: 1
                                }, 8, ["value"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_45, [
                        _createVNode(_component_a_button, {
                          class: "btn",
                          onClick: _ctx.cancelActionInEditRecipient
                        }, {
                          default: _withCtx(() => [
                            _hoisted_46
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_a_button, {
                          class: "btn",
                          type: "primary",
                          onClick: _ctx.saveRecipient
                        }, {
                          default: _withCtx(() => [
                            _hoisted_47
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (!_ctx.isModeEdit && item.status !== 2)
                ? (_openBlock(), _createElementBlock("section", _hoisted_48, [
                    _createVNode(_component_a_dropdown, {
                      placement: "topLeft",
                      trigger: ['click']
                    }, {
                      overlay: _withCtx(() => [
                        _createVNode(_component_a_menu, { class: "teste" }, {
                          default: _withCtx(() => [
                            (_ctx.isSysAdmin || _ctx.isAdmin || _ctx.isOwnerEnvelope)
                              ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "0" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", {
                                      onClick: ($event: any) => (_ctx.editRecipient(item))
                                    }, [
                                      _createVNode(_component_EditOutlined),
                                      _hoisted_50
                                    ], 8, _hoisted_49)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            _createVNode(_component_a_menu_item, { key: "1" }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  onClick: ($event: any) => (_ctx.showLinkSignRecipient(this.envelopeId, item))
                                }, [
                                  _createVNode(_component_LinkOutlined),
                                  _hoisted_52
                                ], 8, _hoisted_51)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_a_menu_item, { key: "2" }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  onClick: ($event: any) => (_ctx.resendNotificationRecipient(this.envelopeId, item))
                                }, [
                                  _createVNode(_component_RetweetOutlined),
                                  _hoisted_54
                                ], 8, _hoisted_53)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          class: "btn-more-details",
                          onClick: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["prevent"]))
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_MoreOutlined)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                : _createCommentVNode("", true)
            ], 2)
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.isShowLinkSignRecipient,
      "onUpdate:visible": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.isShowLinkSignRecipient) = $event)),
      centered: "",
      footer: null,
      maskClosable: false,
      width: "1000px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_55, [
          _createElementVNode("header", _hoisted_56, [
            _hoisted_57,
            _createElementVNode("p", null, [
              _hoisted_58,
              _createElementVNode("b", null, _toDisplayString(_ctx.recipientPartName), 1)
            ])
          ]),
          _createElementVNode("section", _hoisted_59, [
            _createVNode(_component_a_input_group, { compact: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.linkSignRecipient,
                  "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.linkSignRecipient) = $event)),
                  size: "large",
                  disabled: true,
                  class: "cp-lnk"
                }, null, 8, ["value"]),
                _createVNode(_component_a_tooltip, { title: "Copiar link" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      size: "large",
                      onClick: _ctx.copyLinkRecipient
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_CopyOutlined)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("span", _hoisted_60, [
              _createVNode(_component_InfoCircleOutlined),
              _hoisted_61
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}